module.exports = __webpack_public_path__ + "img/logo5.c3835886.png";